import { render, staticRenderFns } from "./digitalClock.vue?vue&type=template&id=7361840c&scoped=true&"
import script from "./digitalClock.vue?vue&type=script&lang=js&"
export * from "./digitalClock.vue?vue&type=script&lang=js&"
import style0 from "./digitalClock.vue?vue&type=style&index=0&id=7361840c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7361840c",
  null
  
)

export default component.exports